<template>
    <div>
    </div>
</template>

<script>
export default {
     name:'read',
    components: {

    },
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {
    },
    methods: {

    },
};
</script>

<style scoped lang="scss">

</style>
